module.exports = __webpack_public_path__ + "9d0ea841c5a470c536de44b8171485c1.png";